import axios from 'axios';
import { stringify } from 'querystring';

import { API_URL } from 'settings';
import { getSettings } from 'utils/settings';
import { getCurrentSessionData } from 'utils/aws/cognito';

const http = axios.create({
  baseURL: API_URL,
});

let THIS_API_CONTEXT = null;

const getDefaultApiContext = () => getSettings('providers.dynamicore.persona_moral.context');

export const setApiContext = (newContext) => {
  THIS_API_CONTEXT = newContext || getDefaultApiContext();
};

http.interceptors.request.use((config) => {
  const { accessToken } = getCurrentSessionData();
  if (accessToken) {
    config.headers.Authorization = accessToken;
  } else {
    delete config.headers.Authorization;
  }

  const resolvedContext = THIS_API_CONTEXT || getDefaultApiContext();
  if (resolvedContext) {
    config.headers.context = resolvedContext;
  } else {
    delete config.headers.context;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      const {
        hash = '',
        pathname,
        search = '',
      } = window.location;
      const query = {};

      if (!pathname.startsWith('/auth/')) {
        query.redirect = Buffer
          .from(`${pathname}${search}${hash}`)
          .toString('base64');
        window.location = `/auth/login?${stringify(query)}`;
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default http;
